import { PluginContainerData_Alignment, PluginContainerData_Width_Type, Node_Type } from 'ricos-schema';
import { Node_Type as Node_Type$1 } from 'ricos-types';
import React, { useState, useLayoutEffect, useMemo, useContext } from 'react';
import { RicosViewerContext, RicosContext } from 'ricos-context';
import { isNumber, upperFirst, camelCase, isFunction } from 'lodash';
import { IMAGE_TYPE as IMAGE_TYPE$1 } from 'ricos-content';
import classNames from 'classnames';
import { Image as Image$2 } from 'wix-rich-content-ui-components';

const DEFAULTS = Object.freeze({
  config: {
    alignment: "center",
    size: "content",
    showTitle: true,
    showDescription: true
  }
});
const RICOS_DEFAULTS = Object.freeze({
  containerData: {
    alignment: PluginContainerData_Alignment.CENTER,
    width: {
      size: PluginContainerData_Width_Type.CONTENT
    },
    textWrap: true
  }
});
({
  settings: `${Node_Type.IMAGE}.settings`,
  imageEditor: `${Node_Type.IMAGE}.imageEditor`
});
({
  size: `${Node_Type.IMAGE}.size`,
  alignment: `${Node_Type.IMAGE}.alignment`
});

const IMAGE_TYPE = "wix-draft-plugin-image";

var styles$1 = {"alignLeft":"NEatQ","textWrapNowrap":"a-ymd","alignRight":"gcOn5","alignCenter":"Eywp-","sizeFullWidth":"_1Fom-","renderedInTable":"NwBKZ","sizeOriginal":"X6WnM","sizeContent":"X02z8","sizeSmall":"sEd8G","sizeSmallCenter":"GAoVs","flex":"PUykV"};

const alignmentClassName = (node) => {
  var _a, _b;
  const { alignment, width } = ((_a = node.imageData) == null ? void 0 : _a.containerData) || {};
  if (!alignment) {
    return "";
  }
  let align = alignment;
  if ((width == null ? void 0 : width.size) === PluginContainerData_Width_Type.ORIGINAL && alignment !== PluginContainerData_Alignment.CENTER) {
    const { width: width2 } = ((_b = node.imageData) == null ? void 0 : _b.image) || {};
    if (isNumber(width2) && width2 > 350) {
      align = PluginContainerData_Alignment.CENTER;
    }
  }
  return styles$1[`align${upperFirst(align.toLowerCase())}`];
};
const sizeClassName = (node, isMobile) => {
  var _a;
  const { width } = ((_a = node.imageData) == null ? void 0 : _a.containerData) || {};
  if (!(width == null ? void 0 : width.size) || isMobile && (width == null ? void 0 : width.size) === PluginContainerData_Width_Type.ORIGINAL) {
    return "";
  }
  return (width == null ? void 0 : width.size) === PluginContainerData_Width_Type.FULL_WIDTH ? styles$1.sizeFullWidth : styles$1[`size${upperFirst(camelCase(width.size.toLowerCase()))}`];
};
const textWrapClassName = (node) => {
  var _a;
  const { textWrap } = ((_a = node.imageData) == null ? void 0 : _a.containerData) || {};
  if (textWrap) {
    return "";
  }
  return styles$1.textWrapNowrap;
};

const getExpandFunction = ({
  helpers,
  config,
  nodeId,
  imageData
}) => {
  const { onExpand, disableExpand } = config;
  if ((imageData == null ? void 0 : imageData.disableExpand) === true || disableExpand === true || !onExpand) {
    return;
  }
  return (e) => {
    var _a;
    e.preventDefault();
    (_a = helpers.onViewerAction) == null ? void 0 : _a.call(helpers, IMAGE_TYPE$1, "Click", "expand_image");
    onExpand(nodeId);
  };
};

const getImageClickActionConfig = ({
  imageData,
  config,
  expand
}) => {
  var _a, _b;
  if (((_a = imageData == null ? void 0 : imageData.link) == null ? void 0 : _a.url) && config) {
    return { type: "link" };
  }
  if ((_b = imageData == null ? void 0 : imageData.link) == null ? void 0 : _b.anchor) {
    return { type: "anchor" };
  }
  if (expand) {
    return { type: "expand", onClick: expand };
  }
  return { type: "regular" };
};

var styles = {"fontElementMap":"eZ5IA","imageContainer":"mzK76","expandContainer":"_9apR4","expandIcon":"oqwlB","pointer":"jZ39i","imageWrapper":"bOQxH","imageRatio":"BrcXw","image":"Epxjd","imageOverlay":"otTe2","imageCaption":"Y5g0g","imagePreload":"DRK1q","imageHighres":"w43ef","onlyHighRes":"Nljb-","image_loading":"eN6CH"};

var __defProp$5 = Object.defineProperty;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b)) {
      if (__propIsEnum$5.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    }
  return a;
};
const expand = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues$5({ viewBox: "0 0 19 19", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M15.071 8.371V4.585l-4.355 4.356a.2.2 0 0 1-.283 0l-.374-.374a.2.2 0 0 1 0-.283l4.356-4.355h-3.786a.2.2 0 0 1-.2-.2V3.2c0-.11.09-.2.2-.2H16v5.371a.2.2 0 0 1-.2.2h-.529a.2.2 0 0 1-.2-.2zm-6.5 6.9v.529a.2.2 0 0 1-.2.2H3v-5.371c0-.11.09-.2.2-.2h.529c.11 0 .2.09.2.2v3.786l4.355-4.356a.2.2 0 0 1 .283 0l.374.374a.2.2 0 0 1 0 .283L4.585 15.07h3.786c.11 0 .2.09.2.2z",
    fill: "#000",
    fillRule: "nonzero"
  }
));

const ROOT = "imageViewer";

var __defProp$4 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
const ImageContainer = (props) => {
  const { type, disableDownload, children } = props;
  const hasOnClick = "onClick" in props;
  const onClick = hasOnClick ? props.onClick : void 0;
  const onKeyDown = onClick ? (e) => {
    if (e.key === "Enter" || e.key === " ") {
      onClick(e);
    }
  } : void 0;
  const interactions = {
    onClick,
    onKeyDown,
    onContextMenu: disableDownload
  };
  const role = hasOnClick || type === "regular" && !!disableDownload ? "button" : void 0;
  const tabIndex = role === "button" ? 0 : void 0;
  return /* @__PURE__ */ React.createElement(
    "figure",
    __spreadProps$2(__spreadValues$4({}, role === "button" ? interactions : {}), {
      role,
      "data-hook": ROOT,
      tabIndex,
      className: styles.imageContainer
    }),
    children
  );
};

const useCustomWidthStyle = ({
  containerData,
  isMobile,
  width
}) => {
  var _a, _b;
  return ((_a = containerData == null ? void 0 : containerData.width) == null ? void 0 : _a.size) === "ORIGINAL" || isMobile && (Number((_b = containerData == null ? void 0 : containerData.width) == null ? void 0 : _b.custom) || 0) > 150 ? { width: width != null ? width : "0px", maxWidth: "100%" } : {};
};

const IMAGE_FALLBACK_WIDTH = 300;
const useFallbackWidthStyle = ({
  containerData,
  isMobile
}) => {
  var _a, _b, _c;
  const shouldUseFallbackWidth = ((containerData == null ? void 0 : containerData.alignment) === "LEFT" || (containerData == null ? void 0 : containerData.alignment) === "RIGHT") && !((_a = containerData.width) == null ? void 0 : _a.custom) && ((_b = containerData.width) == null ? void 0 : _b.size) !== "SMALL" && ((_c = containerData.width) == null ? void 0 : _c.size) !== "ORIGINAL" && !isMobile;
  return shouldUseFallbackWidth ? { width: IMAGE_FALLBACK_WIDTH + "px" } : {};
};

const useImageDimensions = ({
  src,
  containerData,
  image
}) => {
  var _a, _b;
  const [dimensions, setDimensions] = useState({
    width: void 0,
    height: void 0
  });
  const width = (image == null ? void 0 : image.width) || Number((_a = containerData == null ? void 0 : containerData.width) == null ? void 0 : _a.custom) || dimensions.width;
  const height = (image == null ? void 0 : image.height) || Number((_b = containerData == null ? void 0 : containerData.height) == null ? void 0 : _b.custom) || dimensions.height;
  useLayoutEffect(() => {
    if (typeof width === "number" && typeof height === "number") {
      return;
    }
    setDimensions({ width: void 0, height: void 0 });
    if (!src) {
      return;
    }
    const newImg = new Image();
    newImg.onload = () => setDimensions({ width: newImg.width, height: newImg.height });
    newImg.src = src;
    return () => {
      newImg.onload = null;
    };
  }, [src]);
  return {
    width,
    height
  };
};

var __defProp$3 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
const useImageSocialAttributes = ({
  src,
  config,
  width,
  height
}) => {
  if (src === void 0 || (config == null ? void 0 : config.imageProps) === void 0) {
    return {};
  }
  const imageProps = isFunction(config.imageProps) ? config.imageProps({ url: src.url, file_name: src.id, width, height }) : config.imageProps;
  return ["data-pin-nopin", "data-pin-url", "data-pin-media"].reduce(
    (socialAttributes, attribute) => {
      if (imageProps[attribute]) {
        return __spreadProps$1(__spreadValues$3({}, socialAttributes), { [attribute]: imageProps[attribute] });
      }
      return socialAttributes;
    },
    {}
  );
};

var __defProp$2 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const Image$1 = ({
  dataUrl,
  node,
  className,
  config,
  helpers,
  isMobile,
  seoMode,
  imageClickActionConfig,
  expand: expand$1,
  captionComponent,
  shouldLazyLoadImages
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  const containerData = ((_a = node.imageData) == null ? void 0 : _a.containerData) || RICOS_DEFAULTS.containerData;
  const { image, altText } = node.imageData || {};
  const { src } = image || {};
  const disableDownload = ((_b = node.imageData) == null ? void 0 : _b.disableDownload) === true ? (e) => e.preventDefault() : void 0;
  const imageSource = useMemo(() => {
    if (dataUrl) {
      return dataUrl;
    }
    const { url, id } = src || {};
    if (url) {
      return url;
    }
    const { getImageUrl } = helpers != null ? helpers : {};
    if (getImageUrl && id) {
      return getImageUrl({ file_name: id });
    }
    return id;
  }, [
    dataUrl,
    (_e = (_d = (_c = node.imageData) == null ? void 0 : _c.image) == null ? void 0 : _d.src) == null ? void 0 : _e.url,
    (_h = (_g = (_f = node.imageData) == null ? void 0 : _f.image) == null ? void 0 : _g.src) == null ? void 0 : _h.id,
    helpers == null ? void 0 : helpers.getImageUrl
  ]);
  const { width, height } = useImageDimensions({
    src: imageSource,
    containerData,
    image
  });
  const fallbackWidthStyle = useFallbackWidthStyle({ containerData, isMobile });
  const customWidthStyle = useCustomWidthStyle({ containerData, isMobile, width });
  const socialAttributes = useImageSocialAttributes({
    config,
    src,
    width: image == null ? void 0 : image.width,
    height: image == null ? void 0 : image.height
  });
  const doDimensionsExist = width !== void 0 && height !== void 0;
  return /* @__PURE__ */ React.createElement(ImageContainer, __spreadProps(__spreadValues$2({}, imageClickActionConfig), { disableDownload }), doDimensionsExist && imageSource && /* @__PURE__ */ React.createElement(
    Image$2,
    __spreadValues$2({
      id: (_l = (_k = (_j = (_i = node.imageData) == null ? void 0 : _i.image) == null ? void 0 : _j.src) == null ? void 0 : _k.id) != null ? _l : imageSource,
      containerId: node.id,
      displayMode: "fill",
      width,
      height,
      uri: (_p = (_o = (_n = (_m = node.imageData) == null ? void 0 : _m.image) == null ? void 0 : _n.src) == null ? void 0 : _o.id) != null ? _p : imageSource,
      alt: altText || "",
      containerProps: {
        className: classNames(styles.imageWrapper, styles.imageRatio, className, {
          [styles.pointer]: !!expand$1
        }),
        containerId: node.id,
        style: __spreadValues$2(__spreadValues$2({
          ["--dim-height"]: height,
          ["--dim-width"]: width
        }, fallbackWidthStyle), customWidthStyle)
      },
      imageStyles: {
        maxWidth: "100%"
      },
      socialAttrs: socialAttributes,
      isSEOBot: !!seoMode
    }, shouldLazyLoadImages ? {
      placeholderTransition: seoMode ? void 0 : "blur",
      shouldUseLQIP: (config == null ? void 0 : config.disableTransition) !== false
    } : {})
  ), !!expand$1 && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: styles.expandContainer,
      onClick: expand$1,
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          expand$1(e);
        }
      },
      role: "button",
      tabIndex: 0
    },
    /* @__PURE__ */ React.createElement(expand, { className: styles.expandIcon })
  ), captionComponent);
};

const ViewerImageCaption = ({
  imageType,
  caption,
  defaultCaption
}) => {
  const isLinkImage = imageType === "link" || imageType === "anchor";
  const classes = classNames(styles.imageCaption, { [styles.link]: isLinkImage });
  if (!caption || caption === defaultCaption) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("figcaption", { dir: "auto", className: classes }, caption);
};

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ViewerImage = ({ node, nodeIndex, NodeViewContainer }) => {
  var _a, _b;
  const { config: viewerConfig, seoMode, helpers } = useContext(RicosViewerContext);
  const { isMobile, t } = useContext(RicosContext);
  const config = (_a = viewerConfig[IMAGE_TYPE]) != null ? _a : {};
  const expand = getExpandFunction({
    helpers,
    config,
    nodeId: node.id,
    imageData: node.imageData
  });
  const imageClickActionConfig = getImageClickActionConfig({
    imageData: node.imageData,
    config,
    expand
  });
  return /* @__PURE__ */ React.createElement(
    NodeViewContainer,
    {
      node,
      nodeIndex,
      customClassNames: {
        alignment: alignmentClassName(node),
        size: sizeClassName(node, isMobile),
        textWrap: textWrapClassName(node)
      }
    },
    /* @__PURE__ */ React.createElement(
      Image$1,
      {
        node,
        imageClickActionConfig,
        expand,
        config,
        seoMode,
        helpers,
        isMobile,
        shouldLazyLoadImages: true,
        captionComponent: /* @__PURE__ */ React.createElement(
          ViewerImageCaption,
          {
            imageType: imageClickActionConfig.type,
            caption: (_b = node == null ? void 0 : node.imageData) == null ? void 0 : _b.caption,
            defaultCaption: t("ImageViewer_Caption")
          }
        )
      }
    )
  );
};
const ImageRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(ViewerImage, __spreadValues$1({ key: node.id, node }, props));
};

const nodeViewRenderers = {
  [Node_Type$1.IMAGE]: ImageRenderer
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginImage = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: IMAGE_TYPE,
    nodeViewRenderers
  };
};

export { IMAGE_TYPE, pluginImage };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-image/dist/es/styles.viewer.min.global.css'